import { Informe_revisor } from '../../../models/informe_revisor.model';
import { Component} from "@angular/core";
import * as moment from 'moment'
import { FormBuilder, FormControl, FormGroup, Validators } from '@angular/forms';
import { FormService } from 'src/app/services/form.service';
import { MatDatepickerInputEvent } from '@angular/material/datepicker';
declare var jQuery: any;
declare var $: any;
@Component({
    selector: "page-informe_revisor",
    templateUrl: "./informe_revisor.component.html",
    styleUrls: ["./informe_revisor.component.css"],
    providers: [FormService]
})

export class Informe_revisorComponent {
    public rows = [];
    public actualRow;
    public informe_revisor: Informe_revisor;
    public form;
    public fecha_informe;
    public maxDate;
   

    matcher = new FormService();

  constructor(public _formService: FormService, private fb:FormBuilder){

    this.maxDate = moment().toDate()

    this.form = new FormGroup({
        infradio: new FormControl('', Validators.required),
        num_informe: new FormControl('', [Validators.min(0),Validators.pattern(/[0-9]*/)]),
        fecha_informe: new FormControl({value :'', disabled : true})
    })

    if(!JSON.parse(localStorage.getItem("informe_revisor"))){
          localStorage.setItem("informe_revisor", JSON.stringify(this.rows));
    }else{
        this.rows = JSON.parse(localStorage.getItem("informe_revisor"));

        this.form.controls['infradio'].setValue(this.rows[0]?this.rows[0].infradio:false);
        this.form.controls['num_informe'].setValue(this.rows[0]?this.rows[0].num_informe:'')
        this.form.controls['fecha_informe'].setValue(this.rows[0]?new Date(this.rows[0].fecha_informe):null)
      }
      

  }

  add_informe_revisor(event?: MatDatepickerInputEvent<Date>, type?){
    if(event){
            
        this.fecha_informe = moment(event.value).format('DD/MM/YYYY')
        
    } 
    else {
        var temp = JSON.parse(localStorage.getItem("informe_revisor"))
        if(temp > 0){
            this.fecha_informe= temp[0].fecha_informe
            
        }
        
    }
    localStorage.setItem("informe_revisor",JSON.stringify([]));
      this.actualRow = localStorage.getItem("informe_revisor");
      this.rows = JSON.parse(this.actualRow);
      this.rows = this.rows.concat({
        infradio: this.form.value.infradio,
        num_informe : this.form.value.num_informe,
        fecha_informe: moment(this.form.value.fecha_informe).format("DD/MM/YYYY")
      })
      localStorage.setItem("informe_revisor", JSON.stringify(this.rows));
      console.log(this.informe_revisor)
  }

  delete_informe_revisor(id){
      for(let x = 0; x < this.rows.length; x++){
          if(id == x){
              this.rows.splice(x, 1);
              localStorage.setItem("informe_revisor", JSON.stringify(this.rows));
          }
      }
  }  
}